export enum PaymentMethodEnum {
  /** 後払い */
  Atobarai = 'atobarai',
  /** クレジットカード */
  Creditcard = 'creditcard',
}